import { render, staticRenderFns } from "./blame_info.vue?vue&type=template&id=00ec8d08&scoped=true&vue3"
import script from "./blame_info.vue?vue&type=script&lang=js&vue3"
export * from "./blame_info.vue?vue&type=script&lang=js&vue3"
import style0 from "./blame_info.vue?vue&type=style&index=0&id=00ec8d08&prod&scoped=true&lang=css&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ec8d08",
  null
  
)

export default component.exports